import translatorClient from '@/services/client/translator';

export default function translate(i18n, propriete) {
  const proprieteClient = translatorClient(i18n, propriete);
  if (proprieteClient !== propriete) {
    return proprieteClient;
  }
  return propriete;
}
